<template>
  <div id="qqLogin">
    <div class="box container lv2Text">
      <div style="font-size:20px;text-align:center">
        <span style="font-size:28px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(246,78,98,1);">绑定账号</span>
        &nbsp;
        <span style="font-size:16px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(51,51,51,1);">您已验证成功 ! 马上绑定宝枫林账户,下次登录更快捷哦 ! </span>
      </div>
      <div class="content" style="padding:50px 0;">

          <el-tabs  v-model="activeName">
            <el-tab-pane label="您已有宝枫林账号" name="second">
                <el-form>
                  <el-form-item style="margin-top:40px;" >
                    <el-input style="width:320px" v-model="mobile" placeholder="您的手机号"></el-input>
                  </el-form-item>
                  <el-form-item >
                    <el-input style="width:320px" placeholder="密码" type="password" v-model="password"></el-input>
                  </el-form-item>
                  <el-form-item >
                      <el-button @click="submit()" type="primary" style="width:320px;height:48px;">绑定</el-button>
                  </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="没有宝枫林账号" name="f5">
              <el-form>
                  <el-form-item style="margin-top:40px;" >
                    <el-input style="width:320px" v-model="mobile1" placeholder="您的手机号"></el-input>
                  </el-form-item>
                  <el-form-item >
                    <el-input style="width:320px" placeholder="验证码" type="password" v-model="code">
                      <el-button class="code_btn" slot="append" :disabled='disabled_is' @click="emsure()">{{text}}</el-button>
                    </el-input>
                  </el-form-item>
                  <el-form-item >
                    <el-input style="width:320px" placeholder="密码" type="password" v-model="password1"></el-input>
                  </el-form-item>
                  <el-form-item >
                    <el-input style="width:320px" placeholder="确定密码" type="password" v-model="emsure_password"></el-input>
                  </el-form-item>
                  <el-form-item >
                      <el-button @click="submit1()" type="primary" style="width:320px;height:48px;">绑定</el-button>
                  </el-form-item>
                </el-form>
            </el-tab-pane>
          </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import { setInterval, clearInterval } from 'timers';
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,

      mobile:"",
      password:"",
      activeName:'second',
      emsure_password:"",
      mobile1:'',
      password1:'',
      code:"",
      text:'发送验证码',
      disabled_is:false
    };
  },
  created() {
    //
  },
  methods: {
    //
    emsure(){
      this.axios.get(this.serve + '/send_other_register_note',{
        params:{
          send_mobile : this.mobile1
        }
      }).then(res=>{
        if(res.data.status == 'success'){
          this.$message({
            type:"success",
            message: res.data.msg
          })
          var s = 60 ;  
          const _this = this
          var t = setInterval(function(){
            s--
            _this.disabled_is = true;
            _this.text = s + '秒后重新发送'
            if(s == 0){
              clearInterval(t)
              _this.text = "发送验证码"
              _this.disabled_is = false
            }
          },1000)
        }else if(res.data.status == 'error'){
          this.$message.error(res.data.msg)
        }
      })
    },
    submit1(){
      var type = this.$route.query.type;
      var openid = this.$route.query.openid;
      var formdata = new FormData();
      if(type == 'qq'){
        formdata.append('mobile',this.mobile1)
        formdata.append('password',this.password1)
        formdata.append('new_pass',this.emsure_password)
        formdata.append('qq_id',openid);
        formdata.append('code',this.code);
        let config = { headers: { "Content-Type": "multipart/form-data" } };
        this.axios.post(this.serve + '/register_bind_qq',formdata , config).then(res=>{
            if (res.data.status == "success") {
              this.$cookies.set("token", res.data.token);
              this.$cookies.set("user", res.data.mobile);
              this.$router.push("/");
            } else {
              this.$message.error(res.data.msg);
            }
        })
      }else if(type == 'wx'){
        formdata.append('mobile',this.mobile1)
        formdata.append('password',this.password1)
        formdata.append('new_pass',this.emsure_password)
        formdata.append('weChat_id',openid);
        formdata.append('code',this.code);
        let config = { headers: { "Content-Type": "multipart/form-data" } };
        this.axios.post(this.serve + '/register_weChat_bind',formdata , config).then(res=>{
            if (res.data.status == "success") {
              this.$cookies.set("token", res.data.token);
              this.$cookies.set("user", res.data.mobile);
              this.$router.push("/");
            } else {
              this.$message.error(res.data.msg);
            }
        })
      }
    },
    submit() {
      
      var type = this.$route.query.type
      var formdata = new FormData();
      if (type == "qq") {
        formdata.append("mobile", this.mobile);
        formdata.append("password", this.password);
        formdata.append("qq_id", this.$route.query.openid);
        for (var pair of formdata.entries()) {
          // console.log(pair[0] + ", " + pair[1]);
        }
        let config = { headers: { "Content-Type": "multipart/form-data" } };
        this.axios
          .post(this.serve + "/bind_qq", formdata, config)
          .then(res => {
            if (res.data.status == "success") {
              this.$cookies.set("token", res.data.token);
              this.$cookies.set("user", res.data.mobile);
              this.$router.push("/");
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else if (type == "wx") {
        formdata.append("mobile", this.mobile);
        formdata.append("password", this.password);
        formdata.append("weChat_id", this.$route.query.openid);

        let config = { headers: { "Content-Type": "multipart/form-data" } };
        this.axios
          .post(this.serve + "/weChat_bind", formdata, config)
          .then(res => {
            if (res.data.status == "success") {
              this.$cookies.set("token", res.data.token);
              this.$cookies.set("user", res.data.mobile);
              this.$router.push("/");
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    }
  }
};
</script>
<style lang="scss">
#qqLogin {
  padding: 50px 0;
  .t:hover {
    text-decoration: underline;
  }
  .box {
    background-color: #fff;
    padding: 20px;
    .content{
      width:400px;
      margin:0 auto;

      .code_btn{
        // background: #fff;
      }
      .code_btn:hover{
        color: #e2211c;
        
      }
    }
  }
}
</style>